import {storageService} from './storageService';

class WindowGlobalEvents {
    private keyDownKeys:any = {};

    refreshPageDefault() {
        window.onbeforeunload = (e) => {
            if (!storageService.loadFromStorage('isDisableAlert')) {
                const message = 'Are you sure?';

                e.returnValue = message;

                return message;
            }
            storageService.removeFromStorage('isDisableAlert');
        };
    }
    addEventToKeyDown = (key, func, arg:any = [], need_event = false) => this.keyDownKeys[key] = {func, arg, need_event};
    removeEventToKeyDown = (key) => {
        delete this.keyDownKeys[key];

        if (this.keyDownKeys.length === 0) {
            window.removeEventListener('keydown', this.handleKeyDown);
        }
    }
    handleKeyDown = (e) => {
        if (this.keyDownKeys[e.keyCode]) {
            e.preventDefault();
            if (e.target.nodeName.toLowerCase() === 'button') {
                e.stopImmediatePropagation();
            }
            const {func, arg, need_event} = this.keyDownKeys[e.keyCode];

            need_event ? func(e, ...arg) : func(...arg);
        }
    }
}
export default new WindowGlobalEvents();
